export default {
  namespaced: true,
  state: {
    state: [
      { name: '未選択', value: 0 },
      { name: '指導可能', value: 1 },
      { name: '指導不可', value: 2 }
    ],

    gender: [
      { name: '未選択', value: 0 },
      { name: '男', value: 1 },
      { name: '女', value: 2 }
    ],

    school_stage: [
      { name: '未選択', value: 0 },
      { name: '大学4年制', value: 1 },
      { name: '大学院', value: 2 },
      { name: '専門2年制', value: 3 },
      { name: '高校', value: 4 },
      { name: '大学6年制', value: 5 },
      { name: '専門3年制', value: 6 },
      { name: '短大2年制', value: 7 },
      { name: '高専5年制', value: 8 },
      { name: '大学', value: 9 },
      { name: '専門', value: 10 },
      { name: '博士課程', value: 11 }
    ],

    grade: [
      { name: '', value: '' },
      { name: '区分未選択', value: '区分未選択' },
      { name: '高校卒業', value: '高校卒業' },
      { name: '大学1年生', value: '大学1年生' },
      { name: '大学2年生', value: '大学2年生' },
      { name: '大学3年生', value: '大学3年生' },
      { name: '大学4年生', value: '大学4年生' },
      { name: '大学4年制卒業', value: '大学4年制卒業' },
      { name: '大学5年生', value: '大学5年生' },
      { name: '大学6年生', value: '大学6年生' },
      { name: '大学6年制卒業', value: '大学6年制卒業' },
      { name: '大学M1', value: '大学M1' },
      { name: '大学M2', value: '大学M2' },
      { name: '大学院卒業', value: '大学院卒業' },
      { name: '大学D1', value: '大学D1' },
      { name: '大学D2', value: '大学D2' },
      { name: '大学D3', value: '大学D3' },
      { name: '大学卒業', value: '大学卒業' },
      { name: '博士課程卒業', value: '博士課程卒業' },
      { name: '短大1年生', value: '短大1年生' },
      { name: '短大2年生', value: '短大2年生' },
      { name: '短大2年制卒業', value: '短大2年制卒業' },
      { name: '専門1年生', value: '専門1年生' },
      { name: '専門2年生', value: '専門2年生' },
      { name: '専門2年制卒業', value: '専門2年制卒業' },
      { name: '専門3年生', value: '専門3年生' },
      { name: '専門3年制卒業', value: '専門3年制卒業' },
      { name: '専門卒業', value: '専門卒業' },
      { name: '高専5年生', value: '高専5年生' },
      { name: '高専卒業', value: '高専卒業' },
      { name: '中退', value: '中退' }
    ],

    old_grade: [
      { name: '未選択', value: 0 },
      { name: '1', value: 1 },
      { name: '2', value: 2 },
      { name: '3', value: 3 },
      { name: '4', value: 4 },
      { name: '5', value: 5 },
      { name: '6', value: 6 },
      { name: 'M1', value: 7 },
      { name: 'M2', value: 8 },
      { name: 'D1', value: 9 },
      { name: 'D2', value: 10 },
      { name: '卒業', value: 11 },
      { name: '中退', value: 12 }
    ],

    department_type: [
      { name: '未選択', value: 0 },
      { name: '文系', value: 1 },
      { name: '理系', value: 2 },
      { name: '他', value: 3 }
    ],

    impression: [
      { name: '未選択', value: 0 },
      { name: 'AA', value: 1 },
      { name: 'A', value: 2 },
      { name: 'B', value: 3 },
      { name: 'C', value: 4 },
      { name: 'Z', value: 5 },
      { name: '紹介不可', value: 6 }
    ],

    yesno: [
      { name: '無', value: 0 },
      { name: '有', value: 1 }
    ],

    marubatu: [
      { name: '×', value: 0 },
      { name: '○', value: 1 }
    ],

    possible: [
      { name: '未選択', value: 0 },
      { name: 'OK', value: 1 },
      { name: 'NG', value: 2 }
    ],

    training: [
      { name: '未', value: 0 },
      { name: '済', value: 1 }
    ],

    ssk: [
      { name: '未', value: 0 },
      { name: '済', value: 1 }
    ]
  },
  mutations: {},
  actions: {},
  getters: {
    state (state) { return state.state },
    gender (state) { return state.gender },
    school_stage (state) { return state.school_stage },
    grade (state) { return state.grade },
    old_grade (state) { return state.old_grade },
    department_type (state) { return state.department_type },
    impression (state) { return state.impression },
    yesno (state) { return state.yesno },
    marubatu (state) { return state.marubatu },
    possible (state) { return state.possible },
    training (state) { return state.training },
    ssk (state) { return state.ssk }
  }
}



// WEBPACK FOOTER //
// ./src/store/tutors.js